import { inject, Pipe, PipeTransform } from '@angular/core';
import { LanguageService, PublishDateFilterType } from '../../core';


/**
 * Pipe to convert Date Filter enum to display value.
 */
@Pipe({
	name: 'dateFilterLabel'
})
export class DateFilterLabelPipe implements PipeTransform {

	private readonly langSrv = inject(LanguageService);


	transform(planStatus: PublishDateFilterType): string {
		switch (planStatus) {
			case PublishDateFilterType.THISDATE: return this.langSrv.labels().DATE_FILTER_THISDATE;
			case PublishDateFilterType.AFTERDATE: return this.langSrv.labels().DATE_FILTER_AFTERDATE;
			case PublishDateFilterType.BEFOREDATE: return this.langSrv.labels().DATE_FILTER_BEFOREDATE;
			default: return planStatus;
		}
	}

}
